export const formatParams = function formatParams(obj = {}) {
  const filtered = Object.entries(obj).reduce((acc, [key, value]) => {
    if (value !== undefined) acc[key] = value
    return acc
  }, {})
  return new URLSearchParams(filtered).toString()
}

export const request = async function request(url) {
  const response = await fetch(url)

  if (!response.ok) throw new Error(`Request Failed. \nError: ${response.status} - ${response.statusText} `)
  const parsed = await response.json()
  return parsed.data
}
